// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { AvailabilityDto, AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";
import AlertCircleLine from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleLine";
import translate from "@insite/client-framework/Translate";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconWrapper } from "@store/MobiusOverrides/Icon/Icon";

interface OwnProps {
    availability?: AvailabilityDto;
    futureAvailability?: string;
}

export interface availabilityTooltipStyles {
    iconsWrapper?: InjectableCss;
    tooltip?: TooltipPresentationProps;
}

export const availabilityTooltipStyles: availabilityTooltipStyles = {
    iconsWrapper: {
        css: css`
            position: relative;
            right: -${pxToRem(7)};
        `,
    },
    tooltip: {
        iconProps: {
            src: AlertCircleLine,
            color: "danger",
            size: 20,
        },
        cssOverrides: {
            // Css tweaks to make sure the overlay never glitches
            tooltipWrapper: css`
                position: relative;
                display: inline-block;
                margin-left: 0;
                vertical-align: top;
                z-index: 1;
            `,
            tooltipClickable: css`
                height: ${pxToRem(17)};
                width: ${pxToRem(17)};
                padding: 0;

                ${IconWrapper} {
                    cursor: help;
                    height: ${pxToRem(20)} !important;
                    width: ${pxToRem(20)} !important;
                    margin: 0 !important;
                }
            `,
        },
    },
};

const styles = availabilityTooltipStyles;

type Props = OwnProps;

const AvailabilityTooltip = ({ futureAvailability, availability }: Props) => {
    if (availability?.messageType !== AvailabilityMessageType.OutOfStock) {
        return null;
    }

    let message = translate("No expected date exists");
    if (futureAvailability) {
        message = translate("Stock expected: {0}", futureAvailability);
    }

    return (
        <StyledWrapper {...styles.iconsWrapper}>
            <Tooltip {...styles.tooltip} text={message} displayOnHover={true} />
        </StyledWrapper>
    );
};

export default AvailabilityTooltip;
